// Import do dist específico (não do index de @goodfellas/legal) para não
// puxar zod/mongodb para o bundle do site — mesmo padrão dos scripts Node.
import {
  LEGAL_PATHS,
  LEGAL_UPDATED_AT,
  LEGAL_VERSION,
} from '@goodfellas/legal/dist/terms'

/**
 * Metadados dos documentos legais (Termos de Uso e Política de Privacidade).
 *
 * O conteúdo vive em content/legal/<lang>/*.md (PT é o idioma autoritativo;
 * EN é tradução de trabalho). A versão/data vêm de @goodfellas/legal — a
 * MESMA constante que o server usa para registrar o aceite no cadastro e
 * armar o gate de re-aceite no app. Subir a versão lá atualiza o rodapé
 * destas páginas e dispara o re-aceite de todo mundo de uma vez.
 */
export { LEGAL_UPDATED_AT, LEGAL_VERSION }

export const LEGAL_UPDATED_AT_LABEL = {
  pt: '1º de julho de 2026',
  en: 'July 1, 2026',
} as const

export const LEGAL_COMPANY = {
  legalName: 'GOODFELLAS CIÊNCIAS DAS ARTES MARCIAIS LTDA.',
  tradeName: 'GOODFELLAS',
  cnpj: '48.534.700/0001-92',
  address: {
    pt: 'Rua Francisco Conde, 300, Vila Rosália, CEP 07070-010, Guarulhos/SP, Brasil',
    en: 'Rua Francisco Conde, 300, Vila Rosália, ZIP 07070-010, Guarulhos/SP, Brazil',
  },
  contactEmail: 'contato@goodfellas.app',
  privacyEmail: 'privacidade@goodfellas.app',
} as const

export type LegalLang = 'pt' | 'en'
export type LegalDocKey = 'terms' | 'privacy'

export interface LegalDoc {
  /** Arquivo Markdown relativo a content/legal/. */
  file: Record<LegalLang, string>
  /**
   * Path público por idioma. O PT é a rota real da página; o EN é a URL
   * bonita criada por rewrite no next.config.js (/en/termos → redirect).
   */
  path: Record<LegalLang, string>
  title: Record<LegalLang, string>
  description: Record<LegalLang, string>
  /** Complemento da linha de versão no bloco de metadados. */
  scope: Record<LegalLang, string>
}

export const LEGAL_DOCS: Record<LegalDocKey, LegalDoc> = {
  terms: {
    file: { pt: 'pt/termos.md', en: 'en/terms-of-use.md' },
    path: LEGAL_PATHS.terms,
    title: {
      pt: 'Termos e Condições Gerais de Uso',
      en: 'Terms and Conditions of Use',
    },
    description: {
      pt: 'Termos e Condições Gerais de Uso da plataforma Goodfellas.',
      en: 'Terms and Conditions of Use of the Goodfellas platform.',
    },
    scope: {
      pt: 'aplicável a usuários no Brasil e no exterior',
      en: 'applicable to users in Brazil and abroad',
    },
  },
  privacy: {
    file: { pt: 'pt/privacidade.md', en: 'en/privacy-policy.md' },
    path: LEGAL_PATHS.privacy,
    title: {
      pt: 'Política de Privacidade',
      en: 'Privacy Policy',
    },
    description: {
      pt: 'Política de Privacidade da plataforma Goodfellas — LGPD, GDPR e demais leis aplicáveis.',
      en: 'Privacy Policy of the Goodfellas platform — LGPD, GDPR and other applicable laws.',
    },
    scope: {
      pt: 'LGPD, GDPR e demais leis aplicáveis',
      en: 'LGPD, GDPR and other applicable laws',
    },
  },
}
